import { Button, ButtonTheme } from '@cian/button-component';
import { Outside } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import { IAgentSchema, IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { EFeedbackComplaint } from '../../../store/complaint/feedback_complaint';
import { getCustomUrl } from '../../../utils/tracking/getCustomUrl';
import { ComplaintContainer } from '../../complaint/container';
import * as styles from './index.css';
import { trackClick } from './tracking';

export interface IComplaintButtonProps {
  agent: IAgentSchema | null;
  className?: string;
  offer: IOfferSchema;
  complaintFeedbackFormStatus(status: EFeedbackComplaint): void;
  resetPrefilledEmail(): void;
}

interface IComplaintButtonState {
  isComplaintPopupOpen: boolean;
}

export class ComplaintButton extends React.PureComponent<IComplaintButtonProps, IComplaintButtonState> {
  public constructor(props: IComplaintButtonProps) {
    super(props);

    this.state = {
      isComplaintPopupOpen: false,
    };
  }

  public render() {
    const { className } = this.props;
    const { isComplaintPopupOpen } = this.state;

    return (
      <span className={cn(styles['container'], className)}>
        <Button
          className={styles['button']}
          onClick={this.handleClickOnButton}
          theme={ButtonTheme.Ghost}
          title="Пожаловаться"
        >
          Пожаловаться
        </Button>
        {isComplaintPopupOpen && (
          <Outside onOutside={this.handleOutsideClick} active={isComplaintPopupOpen} insideRefs={[]}>
            <div className={styles['tooltip']}>
              <ComplaintContainer handleOutsideClick={this.handleOutsideClick} />
            </div>
          </Outside>
        )}
      </span>
    );
  }

  private handleClickOnButton = () => {
    trackClick(getCustomUrl(this.props.offer, this.props.agent));
    this.setState(({ isComplaintPopupOpen }) => ({ isComplaintPopupOpen: !isComplaintPopupOpen }));
  };

  private handleOutsideClick = () => {
    this.setState({ isComplaintPopupOpen: false });
    this.props.complaintFeedbackFormStatus(EFeedbackComplaint.default);
    this.props.resetPrefilledEmail();
  };
}
